import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInstagram, faLinkedin, faFacebook, faGithub, faStackOverflow } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faGlobeEurope } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.less'],
  imports: [FontAwesomeModule]
})
export class LinksComponent {
  @Input() GitHub = ''; //GitHub URL
  @Input() Instagram = ''; //Instagram URL
  @Input() Stackoverflow = ''; //GitHub URL
  @Input() Facebook = '';
  @Input() LinkedIn = ''; // LinkedIn URL
  @Input() Web = ''; // Web URL
  @Input() Mail = ''; // Email Address

  faInstagram = faInstagram;
  faEnvelope = faEnvelope;
  faLinkedin = faLinkedin;
  faGlobeEurope = faGlobeEurope;
  faFacebook = faFacebook;
  faGithub = faGithub;
  faStackoverflow = faStackOverflow;
}
